import { styled } from '@mui/material/styles';
import { buttonBaseClasses } from '@mui/material/ButtonBase';
import { MuiDatePicker } from '../../../../../modules/material';

export const StyledDatePicker = styled(MuiDatePicker)(({ theme }) => ({
  [`.${buttonBaseClasses.root}`]: {
    color: theme.palette.brandSecondary.mainCustom,
  },
}));
